import React from 'react';

const RepositoryBranchTooltip: React.FC = () => {
  return (
    <div className="p-1 overflow-auto" style={{ maxWidth: '600px' }}>
      <strong className="mb-4">
        Displays (repository name) / (branch name) with related details on
        tooltip
      </strong>

      <table className="table table-bordered table-striped table-hover">
        <thead className="thead-light">
          <tr>
            <th className="p-1" style={{ width: '80px', textAlign: 'left' }}>
              Indicator
            </th>
            <th className="p-1" style={{ textAlign: 'left' }}>
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              <span style={{ color: '#d32f2f' }}>
                <i className="fas fa-exclamation-triangle fa-lg" />
              </span>
              <span className="ml-2">Red</span>
            </td>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Build errors in .NET/Java projects. View build logs for detailed
              error information.
            </td>
          </tr>
          <tr>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              <span style={{ color: '#ffc107' }}>
                <i className="fas fa-exclamation-triangle fa-lg" />
              </span>
              <span className="ml-2">Yellow</span>
            </td>
            <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
              Indicates unscanned languages. Some languages could not be scanned
              due to the following reasons:
              <ul className="mb-0 mt-1">
                <li>Source files are empty or some other code issues.</li>
                <li>
                  Language is not supported. For a list of supported languages,
                  refer to the documentation.
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default RepositoryBranchTooltip;
